import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader, RefreshCw } from 'lucide-react';
import type { ProvisioningInventory, ProvisioningPack, ProvisioningServerRequest } from '../../types/modpackProvisioning';
import { modpackProvisioningApi } from '../../services/modpackProvisioningApi';
import { ProvisioningForm } from './ProvisioningForm';
import { ErrorNotice } from './MachineJobDisplay';
import { useAuth } from '../../contexts/AuthContext';
import { getStaffPerms } from '../../utils/staffPermissions';

export function ProvisioningEntry({ defaults }: { defaults?: { pack?: Partial<ProvisioningPack>; server?: Partial<ProvisioningServerRequest> } }) {
  const navigate = useNavigate();
  const { identity } = useAuth();
  const canManage = getStaffPerms(identity, import.meta.env.DEV).canManage;
  const [inventory, setInventory] = useState<ProvisioningInventory | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    modpackProvisioningApi.inventory(controller.signal).then(result => {
      if (!controller.signal.aborted) { setInventory(result); setError(null); }
    }).catch(failure => { if (!controller.signal.aborted) setError(failure instanceof Error ? failure.message : 'Machines could not be loaded.'); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [reload]);
  return <div className="space-y-4">
    {loading && !inventory && <p role="status" className="text-sm flex gap-2 items-center py-1"><Loader className="w-4 h-4 animate-spin" />Checking machines and templates…</p>}
    {error && <><ErrorNotice text={error} /><button type="button" className="glass-button" disabled={loading} onClick={() => setReload(value => value + 1)}><RefreshCw className="w-4 h-4" />Retry</button></>}
    {inventory && <ProvisioningForm inventory={inventory} canManage={canManage} refreshing={loading || !!error} defaults={defaults} onRefresh={() => setReload(value => value + 1)} onCreated={id => navigate(`/modpack-configs/provisioning?job=${encodeURIComponent(id)}`)} />}
  </div>;
}
